import axios from 'axios'
import dayjs from "dayjs";

const store = {
    namespaced: true,
    state: {
        jobs: [],
        currentJob: null,
        currentCredential: null,
        currentSchema: null,
        currentMapping: null,
        currentDataChannel: null,
        currentQuery: null,
        currentCredentialType: null,
        credentials: [],
        schemas: [],
        mappings: [],
        dataChannels: [],
        queries: [],
        credentialTypes: [],
        folderPath: "",
        sandboxCredentials: [],
        selectedCredential: null,
        pipelines: [],
        jobKinds: [],
        configurations: [],
        flowSet: [],
        jobTypes: [],
        cidJobTemplates: [],
        lakeviewParameters: [],
        usageData: {},
        usageDataStartDate: dayjs().startOf('month').format("YYYY-MM-DD"),
        usageDataEndDate: dayjs().format("YYYY-MM-DD"),
        usageMonth: dayjs().format('MM'),
        mmdChats: null,
        t2mdChats: null,
        mmdAdminChats: null,
        t2mdAdminChats: null,
        mmdCurrentChat: null,
        t2mdCurrentChat: null,
        mmdChatLimit: 10,
        t2mdChatLimit: 10,
        mmdAdminChatLimit: 10,
        t2mdAdminChatLimit: 10,
        templateJobs:[],
        jobStacks:[],
        countsMetricReqObj: {
            "amdp-performance-metric": {
                "version": "1.0.1",
                "header": [
                    "mode",
                    "stage",
                    "group_name",
                    "count",
                    "cpu_allocated",
                    "cpu_used",
                    "cpu_utilized",
                    "cpu_utilized_min",
                    "cpu_utilized_avg",
                    "cpu_utilized_max",
                    "memory_allocated",
                    "memory_utilized",
                    "memory_utilized_min",
                    "memory_utilized_avg",
                    "memory_utilized_max",
                    "succeeded",
                    "pending",
                    "duration_min",
                    "duration_avg",
                    "duration_max",
                    "pending_duration_min",
                    "pending_duration_avg",
                    "pending_duration_max"
                ]
            },
            "amdp-job-run-params": {
                "version": "1.0.1"
            },
            "amdp-metric": {
                "version": "1.0.1",
                "header": [
                    "data_channel",
                    "data_channel_type",
                    "record_schema",
                    "schema_version",
                    "file_count",
                    "error_file_count",
                    "record_count",
                    "quarantine_record_count",
                    "byte_count"
                ]
            }
        }
    },
    mutations: {
        setCurrentJob(state, job) {
            state.currentJob = job
        },
        setCurrentCredential(state, credential) {
            state.currentCredential = credential
        },
        setCurrentSchema(state, schema) {
            state.currentSchema = schema
        },
        setCurrentMapping(state, mapping) {
            state.currentMapping = mapping
        },
        setCurrentDataChannel(state, dataChannel) {
            state.currentDataChannel = dataChannel
        },
        setCurrentQuery(state, query) {
            state.currentQuery = query
        },
        setCurrentCredentialType(state, credentialType) {
            state.currentCredentialType = credentialType
        },
        setJobs(state, jobs) {
            state.jobs = jobs
        },
        setSchemas(state, schemas) {
            state.schemas = schemas
        },
        setMappings(state, mappings) {
            state.mappings = mappings
        },
        setCredentials(state, credentials) {
            state.credentials = credentials
        },
        setDataChannels(state, dataChannels) {
            state.dataChannels = dataChannels
        },
        setQueries(state, queries) {
            state.queries = queries
        },
        setCredentialTypes(state, credentialTypes) {
            state.credentialTypes = credentialTypes
        },
        setFolderPath(state, folderPath) {
            state.folderPath = folderPath
        },
        setSandboxCredentials(state, sandboxCredentials) {
            state.sandboxCredentials = sandboxCredentials
        },
        setSelectedCredential(state, selectedCredential) {
            state.selectedCredential = selectedCredential
        },
        setPipelines(state, pipelines) {
            state.pipelines = pipelines;
        },
        setJobKinds(state, jobKinds) {
            state.jobKinds = jobKinds;
        },
        setFlowSets(state, flowSet) {
            state.flowSet = flowSet
        },
        setJobTypes(state, jobTypes) {
            state.jobTypes = jobTypes;
        },
        setConfigurations(state, configurations) {
            state.configurations = configurations
        },
        setCidJobTemplates(state, cidJobTemplates) {
            state.cidJobTemplates = cidJobTemplates
        },
        setLakeviewParameters(state, lakeviewParameters) {
            state.lakeviewParameters = lakeviewParameters
        },
        setUsageData(state, data) {
            state.usageData = data
        },
        setUsageDataStartDate(state, startDate) {
            state.usageDataStartDate = startDate
        },
        setUsageDataEndDate(state, endDate) {
            state.usageDataEndDate = endDate
        },
        setUsageMonth(state, month) {
            state.usageMonth = month
        },
        setMMDChats(state, chats) {
            state.mmdChats = chats
        },
        setT2MDChats(state, chats) {
            state.t2mdChats = chats
        },
        setMMDCurrentChat(state, chat) {
            state.mmdCurrentChat = chat
        },
        setT2MDCurrentChat(state, chat) {
            state.t2mdCurrentChat = chat
        },
        setMMDAdminChats(state, chats) {
            state.mmdAdminChats = chats
        },
        setT2MDAdminChats(state, chats) {
            state.t2mdAdminChats = chats
        },
        setMMDChatLimit(state, limit) {
            state.mmdChatLimit = limit
        },
        setT2MDChatLimit(state, limit) {
            state.t2mdChatLimit = limit
        },
        setMMDAdminChatLimit(state, limit) {
            state.mmdAdminChatLimit = limit
        },
        setT2MDAdminChatLimit(state, limit) {
            state.t2mdAdminChatLimit = limit
        },
        setTemplateJobs(state, jobs) {
            state.templateJobs = jobs
        },
        setJobStacks(state, jobs) {
            state.jobStacks = jobs
        },
    },
    actions: {
        setCurrentJob({ commit }, job) {
            commit('setCurrentJob', job)
        },
        setCurrentCredential({ commit }, credential) {
            commit('setCurrentCredential', credential)
        },
        setCurrentSchema({ commit }, schema) {
            commit('setCurrentSchema', schema)
        },
        setCurrentMapping({ commit }, mapping) {
            commit('setCurrentMapping', mapping)
        },
        setCurrentDataChannel({ commit }, dataChannel) {
            commit('setCurrentDataChannel', dataChannel)
        },
        setCurrentQuery({ commit }, query) {
            commit('setCurrentQuery', query)
        },
        setCurrentCredentialType({ commit }, credentialType) {
            commit('setCurrentCredentialType', credentialType)
        },
        setFolderPath({ commit }, folderPath) {
            commit('setFolderPath', folderPath)
        },
        setSandboxCredentials({ commit }, sandboxCredentials) {
            commit('setSandboxCredentials', sandboxCredentials)
        },
        setSelectedCredential({ commit }, selectedCredential) {
            commit('setSelectedCredential', selectedCredential)
        },
        setFlowSets({ commit }, flowSet) {
            commit('setFlowSetss', flowSet)
        },
        setUsageData({ commit }, data) {
            commit('setUsageData', data)
        },
        setUsageDataStartDate({ commit }, startDate) {
            commit('setUsageDataStartDate', startDate)
        },
        setUsageDataEndDate({ commit }, endDate) {
            commit('setUsageDataEndDate', endDate)
        },
        setUsageMonth({ commit }, month) {
            commit('setUsageMonth', month)
        },
        setCidJobTemplates({ commit }, jobTemplates) {
            commit('setCidJobTemplates', jobTemplates)
        },
        setLakeviewParameters({ commit }, lakeviewParameters) {
            commit('setLakeviewParameters', lakeviewParameters)
        },
        setMMDCurrentChat({ commit }, chat) {
            commit('setMMDCurrentChat', chat)
        },
        setT2MDCurrentChat({ commit }, chat) {
            commit('setT2MDCurrentChat', chat)
        },
        setMMDChatLimit({ commit }, limit) {
            commit('setMMDChatLimit', limit)
        },
        setT2MDChatLimit({ commit }, limit) {
            commit('setT2MDChatLimit', limit)
        },
        setMMDAdminChatLimit({ commit }, limit) {
            commit('setMMDAdminChatLimit', limit)
        },
        setT2MDAdminChatLimit({ commit }, limit) {
            commit('setT2MDAdminChatLimit', limit)
        },
        setChats({ commit }, params) {
            const { feature, chats, adminHistory } = params;

            if (feature === 'map_my_data') {
                if (adminHistory) {
                    commit('setMMDAdminChats', chats)
                } else {
                    commit('setMMDChats', chats)
                }
            } else if (feature === 'talk_to_my_data') {
                if (adminHistory) {
                    commit('setT2MDAdminChats', chats)
                } else {
                    commit('setT2MDChats', chats)
                }
            }
        },
        onClientChange({ commit }) {
            commit('setJobs', [])
            commit('setCredentials', [])
            commit('setQueries', [])
            commit('setCurrentQuery', null)
            commit('setMMDChats', null)
            commit('setT2MDChats', null)
            commit('setMMDCurrentChat', null)
            commit('setT2MDCurrentChat', null)
            commit('setMMDAdminChats', null)
            commit('setT2MDAdminChats', null)
        },
        fetchJobs({ rootState, state, commit }, sandboxName) {
            commit('setJobs', [])
            axios.get(rootState.lakeviewUrl + `/v1/cids/${rootState.currentClient.cid}/sandboxes/${sandboxName}/jobs`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            }).then((response) => {
                let jobs = response.data;
                commit('setJobs', jobs)
                if (!state.currentJob)
                    commit('setCurrentJob', jobs[0])
            }).catch((e) => {
                commit('setJobs', [])
            })
        },
        fetchMappings({ rootState, state, commit }) {
            axios.get(rootState.lakeviewUrl + `/v1/cids/${rootState.currentClient.cid}/config/mappings`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            }).then((response) => {
                let data = response.data

                let schemas = data.schemas
                schemas = Object.keys(schemas).map(function (key) {
                    return {
                        ...schemas[key],
                        'id': key,
                        'name': key.replace(/_/g, ' ')
                    }
                });
                commit('setSchemas', schemas)
                if (!state.currentSchema)
                    commit('setCurrentSchema', schemas[0])

                let mappings = data.schema_mappings
                mappings = Object.keys(mappings).map(function (key) {
                    return {
                        ...mappings[key],
                        'id': key,
                        'name': key.replace(/_/g, ' ')
                    }
                });
                commit('setMappings', mappings)
                if (!state.currentMapping)
                    commit('setCurrentMapping', mappings[0])
            });
        },
        fetchConfigCredentials({ rootState, state, commit }) {
            axios.get(rootState.lakeviewUrl + `/v1/cids/${rootState.currentClient.cid}/config/credentials`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            }).then((response) => {
                let credentials = response.data[rootState.currentClient.cid];
                credentials = Object.keys(credentials).map(function (key) {
                    return {
                        ...credentials[key],
                        'id': key,
                        'name': key.replace(/_/g, ' ')
                    }
                });
                commit('setCredentials', credentials)
                if (!state.currentCredential)
                    commit('setCurrentCredential', credentials[0])
            });
        },
        fetchCredentials({ rootState, state, commit }) {
            axios.get(rootState.clientMgmtUrl + `/v1/clients/${rootState.currentClient.cid}/credentials`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            }).then(function (response) {
                let credentials = response.data;
                commit('setCredentials', credentials)
                if (!state.currentCredential)
                    commit('setCurrentCredential', credentials[0])

            });
        },
        fetchDataChannels({ rootState, state, commit }) {
            axios.get(rootState.lakeviewUrl + `/v1/cids/${rootState.currentClient.cid}/config/data_channels`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            }).then((response) => {
                let channels = response.data[rootState.currentClient.cid];
                channels = Object.keys(channels).map(function (key) {
                    return {
                        ...channels[key],
                        'id': key,
                        'name': key.replace(/_/g, ' ')
                    }
                });
                commit('setDataChannels', channels)
                if (!state.currentDataChannel)
                    commit('setCurrentDataChannel', channels[0])
            });
        },
        fetchQueries({ rootState, state, commit }) {
            axios.get(rootState.pailUrl + `/${rootState.pailVersion}/cids/${rootState.currentClient.cid}/named_queries`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            }).then((response) => {
                let queries = response.data
                commit('setQueries', queries)
                if (!state.currentQuery)
                    commit('setCurrentQuery', queries[0])
            });
        },
        fetchUsageData({ rootState, dispatch, state, commit }, usageType) {
            // Reset only the specific usageType 
            commit('setUsageData', {
                ...state.usageData,
                [usageType]: {}
            });

            let payload = {
                startDate: state.usageDataStartDate,
                endDate: state.usageDataEndDate,
                product: 'amdp',
                usageType: usageType
            };
            dispatch('usage/getProductUsage', payload, { root: true }).then((data) => {
                if (data && data[payload.product]) {
                    // Update only the specific usageType portion while preserving other data
                    commit('setUsageData', {
                        ...state.usageData,
                        [usageType]: data[payload.product]
                    });
                }
            });

        },
        async readJob({ rootState, state }, params) {
            return axios.get(rootState.lakeviewUrl + `/v1/cids/${rootState.currentClient.cid}/sandboxes/${params.sandboxName}/jobs/${params.jobName}`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async fetchJobRuns({ rootState, state }, jobName) {
            return axios.get(rootState.lakeviewUrl + `/v1/cids/${rootState.currentClient.cid}/sandboxes/default/jobs/${jobName}/executions`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async fetchParamDefs({ rootState }) {
            return axios.get(rootState.pailUrl + `/${rootState.pailVersion}/cids/${rootState.currentClient.cid}/param_defs`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`
                }
            }).then((response) => {
                return response.data;
            })

        },
        async fetchFullQueryFile({ rootState }, query_id) {
            return axios.get(rootState.pailUrl + `/${rootState.pailVersion}/cids/${rootState.currentClient.cid}/query_result_link/${query_id}`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`
                }
            }).then((response) => {
                return response.data;
            })
        },
        async createQuery({ rootState }, queryPayload) {
            return axios.post(rootState.pailUrl + `/${rootState.pailVersion}/cids/${rootState.currentClient.cid}/named_queries`, queryPayload, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`
                }
            })
        },
        async readQuery({ rootState }, id) {
            return axios.get(rootState.pailUrl + `/${rootState.pailVersion}/cids/${rootState.currentClient.cid}/named_queries/` + id, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async updateQuery({ rootState }, queryPayload) {
            return axios.put(rootState.pailUrl + `/${rootState.pailVersion}/cids/${rootState.currentClient.cid}/named_queries/${queryPayload.Name}`, queryPayload, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async deleteQuery({ rootState }, queryPayload) {
            return axios.delete(rootState.pailUrl + `/${rootState.pailVersion}/cids/${rootState.currentClient.cid}/named_queries/${queryPayload.Name}`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async createParam({ rootState }, paramPayload) {
            return axios.post(rootState.pailUrl + `/${rootState.pailVersion}/cids/${rootState.currentClient.cid}/param_defs`, paramPayload, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`
                }
            })
        },
        async fetchCredentialTypes({ rootState, state, commit }) {
            return axios.get(rootState.clientMgmtUrl + `/v1/credential_types`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`
                }
            }).then((response) => {
                let credentialTypes = response.data
                commit('setCredentialTypes', credentialTypes)
                if (!state.currentQuery)
                    commit('setCurrentCredentialType', credentialTypes[0])
            })
        },
        async createCredential({ rootState }, credentailPayload) {
            return axios.post(rootState.clientMgmtUrl + `/v1/clients/${rootState.currentClient.cid}/credentials`, credentailPayload, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`
                }
            })
        },
        async updateCredential({ rootState }, { credentialPayload, referenceCredName }) {
            return axios.put(rootState.clientMgmtUrl + `/v1/clients/${rootState.currentClient.cid}/credentials/` + referenceCredName, credentialPayload, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async deleteCredential({ rootState }, credentialName) {
            return axios.delete(rootState.clientMgmtUrl + `/v1/clients/${rootState.currentClient.cid}/credentials/` + credentialName, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async readCredential({ rootState }, id) {
            return axios.get(rootState.clientMgmtUrl + `/v1/clients/${rootState.currentClient.cid}/credentials/` + id, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async getFileBrowserList({ rootState }, param) {
            return axios.get(rootState.surfaceUrl + `/v1/cids/${rootState.currentClient.cid}/sandboxes/${param.sandboxName}/browser/list?folder=` + param.folderName, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async getBucketList({ rootState }, param) {
            return axios.get(rootState.surfaceUrl + `/v1/cids/${rootState.currentClient.cid}/sandboxes/${param.sandboxName}/bucketlist/${param.type}?credential=` + param.credential, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async getPresignURL({ rootState }, param) {
            return axios.get(rootState.surfaceUrl + `/v1/cids/${rootState.currentClient.cid}/sandboxes/${param.sandboxName}/browser/${param.operation}?filename=` + param.filePath, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async deleteFiles({ rootState }, filepath) {
            return axios.delete(rootState.surfaceUrl + `/v1/cids/${rootState.currentClient.cid}/file/` + filepath, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async getSandboxCredentials({ rootState, commit }, sandboxName) {
            return axios.get(rootState.lakeviewUrl + `/v1/cids/${rootState.currentClient.cid}/sandboxes/${sandboxName}/credentials`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            }).then((response) => {
                commit('setSandboxCredentials', response.data);
                return response
            })
        },
        async upsertSandboxCredential({ rootState }, { sandboxName, payload }) {
            return axios.put(rootState.lakeviewUrl + `/v1/cids/${rootState.currentClient.cid}/sandboxes/${sandboxName}/credentials`, payload, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`
                }
            })
        },
        async uploadPresignURLFile({ rootState }, param) {
            await axios.put(param.signedUrl, param.file, {
                headers: {
                    'Content-Type': param.file.type
                }
            });
        },
        async fetchOutputParser({ rootState }, payload) {
            return axios.post(rootState.surfaceUrl + `/v1/output_parser`, payload, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async fetchPipelines({ rootState, state, commit }, sandboxName) {
            commit('setPipelines', [])
            axios.get(rootState.lakeviewUrl + `/v1/cids/${rootState.currentClient.cid}/sandboxes/${sandboxName}/jobs?job_kind=pipeline`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            }).then((response) => {
                commit('setPipelines', response.data)
            }).catch((e) => {
                commit('setPipelines', [])
            })
        },

        async stopQueryExecutions({ rootState }, execution_id) {
            return axios.post(rootState.pailUrl + `/${rootState.pailVersion}/cids/${rootState.currentClient.cid}/query_executions/${execution_id}`, {}, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                }
            });
        },

        async fetchJobKinds({ rootState, commit }) {
            return axios.get(rootState.lakeviewUrl + `/v1/job_kinds`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                }
            }).then((response) => {
                commit('setJobKinds', response.data.job_kinds);
                return response;
            })
        },
        async fetchConfigurations({ rootState, state, commit }) {
            return axios.get(rootState.surfaceUrl + `/v1/cids/${rootState.currentClient.cid}/input_streams`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`
                }
            }).then((response) => {
                let configurations = response.data
                commit('setConfigurations', configurations)
            }).catch((e) => {
                commit('setConfigurations', [])
            })
        },
        async createConfiguration({ rootState }, configurationPayload) {
            return axios.post(rootState.surfaceUrl + `/v1/cids/${rootState.currentClient.cid}/input_streams`, configurationPayload, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`
                }
            })
        },
        async updateConfiguration({ rootState }, configurationPayload) {
            console.log(configurationPayload);
            return axios.put(rootState.surfaceUrl + `/v1/cids/${rootState.currentClient.cid}/input_streams/` + configurationPayload.id, configurationPayload, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async deleteConfiguration({ rootState }, id) {
            return axios.delete(rootState.surfaceUrl + `/v1/cids/${rootState.currentClient.cid}/input_streams/` + id, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async readConfiguration({ rootState }, id) {
            return axios.get(rootState.surfaceUrl + `/v1/cids/${rootState.currentClient.cid}/input_streams/` + id, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },

        async fetchFlowSets({ rootState, state, commit }) {
            return axios.get(rootState.surfaceUrl + `/v1/cids/${rootState.currentClient.cid}/flow_set`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`
                }
            }).then((response) => {
                let flowSet = response.data
                commit('setFlowSets', flowSet)
            }).catch((e) => {
                commit('setFlowSets', [])
            })
        },
        async createFlowSet({ rootState }, payload) {
            return axios.post(rootState.surfaceUrl + `/v1/cids/${rootState.currentClient.cid}/flow_set`, payload, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`
                }
            })
        },
        async updateFlowSet({ rootState }, payload) {
            return axios.put(rootState.surfaceUrl + `/v1/cids/${rootState.currentClient.cid}/flow_set/` + payload.id, payload, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async deleteFlowSet({ rootState }, id) {
            return axios.delete(rootState.surfaceUrl + `/v1/cids/${rootState.currentClient.cid}/flow_set/` + id, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async readFlowSet({ rootState }, id) {
            return axios.get(rootState.surfaceUrl + `/v1/cids/${rootState.currentClient.cid}/flow_set/` + id, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },

        async getJobTemplateGroups({ rootState }, param) {
            return axios.get(rootState.surfaceUrl + `/v1/job_template_group`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },

        async fetchCidJobTemplates({ rootState, commit }, queryPayload) {
            commit('setCidJobTemplates', [])
            return axios.get(rootState.surfaceUrl + `/v1/cids/${rootState.currentClient.cid}/job_templates`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
                params: queryPayload
            }).then((response) => {
                const cidJobTemplates = response.data ? response.data : [];
                commit('setCidJobTemplates', cidJobTemplates)
                return cidJobTemplates;
            }).catch((error) => {
                throw error
            });
        },
        async fetchJobTypes({ rootState, commit }) {
            return axios.get(rootState.lakeviewUrl + `/v1/job_types`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                }
            }).then((response) => {
                commit('setJobTypes', response.data);
                return response;
            })
        },
        async fetchLakeviewParameters({ rootState, commit }, params) {
            commit('setLakeviewParameters', [])
            return axios.get(rootState.lakeviewUrl + `/v1/cids/${rootState.currentClient.cid}/sandboxes/${params.sandboxName}/jobs/${params.jobName}/parameters`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                }
            }).then((response) => {
                const lakeviewParameters = response.data.parameters ? response.data.parameters : [];
                commit('setLakeviewParameters', lakeviewParameters);
            }).catch((error) => {
                console.log("Error fetching parameters: ", error)
            });
        },
        async updateLakeviewParameters({ rootState, commit }, params) {
            return axios.put(rootState.lakeviewUrl + `/v1/cids/${rootState.currentClient.cid}/sandboxes/${params.sandboxName}/jobs/${params.jobName}/parameters`, params.payload, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                }
            });
        },
        async getDatasetSchema({ rootState }, params) {
            return axios.get(rootState.audsumUrl + `/audience/v1/cids/${rootState.currentClient.cid}/data_environments/${params.data_environment}/datasets/${params.dataset}`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                }
            }).catch((error) => {
                console.error("Error fetching dataset schema details: ", error)
                throw error;
            });
        },
        async createAudsumHistogramQuery({ rootState, state }, params) {
            let headers = {
                Authorization: `Bearer ${rootState.accessToken}`,
            }
            if (params.skipCacheHeader) headers['Audsum-Skip-Cache'] = params.skipCacheHeader;
            let qp = params.query_engine ? "?query_engine=" + params.query_engine : "";
            return axios.post(rootState.audsumUrl + `/audience/v1/cids/${rootState.currentClient.cid}/data_environments/${params.data_environment}/datasets/${params.dataset}/histogram` + qp, params.payload, {
                headers: headers
            })
        },
        async getAudsumExecution({ rootState, state }, params) {
            return axios.get(rootState.audsumUrl + `/audience/v1/cids/${rootState.currentClient.cid}/data_environments/${params.data_environment}/datasets/${params.dataset}/executions/${params.execution_id}`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                }
            }).catch((error) => {
                console.error("Error fetching query details: ", error)
                throw error;
            });
        },
        async graphMyData({ rootState }, payload) {
            // Return the fetch response directly for streaming
            const endpoint = `${rootState.agentsUrl}/v1/graph_my_data`;
            
            return fetch(endpoint, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "text/event-stream",
                    "Authorization": `Bearer ${rootState.accessToken}`
                },
                body: JSON.stringify({
                    cid: rootState.currentClient.cid,
                    ...payload
                })
            });
        },

        // endpoints for agent's chat history
        async createChat({ rootState }, payload) {
            return axios.post(rootState.agentsUrl + `/v1/${payload.feature}/cids/${rootState.currentClient.cid}/chats`, payload.create_chat_payload, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async updateChatTitle({ rootState }, payload) {
            return axios.post(rootState.agentsUrl + `/v1/${payload.feature}/cids/${rootState.currentClient.cid}/chats/${payload.resourceId}/title`, payload.message_payload, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async upsertChatMessage({ rootState }, payload) {
            const httpMethod = payload.method ? payload.method.toLowerCase() : 'post';
            return axios[httpMethod](rootState.agentsUrl + `/v1/${payload.feature}/cids/${rootState.currentClient.cid}/chats/${payload.resourceId}/messages`, payload.message_payload, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async getChats({ rootState, dispatch, state }, payload) {
            let adminHistory = !!payload.adminHistory;

            if (payload.feature == "map_my_data") {
                if (adminHistory) {
                    if (!payload.forceGet && state.mmdAdminChats != null) return;
                } else {
                    if (!payload.forceGet && state.mmdChats != null) return;
                }
            } else if (payload.feature == "talk_to_my_data") {
                if (adminHistory) {
                    if (!payload.forceGet && state.t2mdAdminChats != null) return;
                } else {
                    if (!payload.forceGet && state.t2mdChats != null) return;
                }
            }

            dispatch('setChats', {feature: payload.feature, chats: [], adminHistory: adminHistory})
            let qp = []
            if (payload.limit) qp.push(`limit=${payload.limit}`)
            if (adminHistory) qp.push(`admin_history=true`)
            return axios.get(rootState.agentsUrl + `/v1/${payload.feature}/cids/${rootState.currentClient.cid}/chats` + (qp.length ? `?${qp.join('&')}` : ''), {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            }).then((response) => {
                let chats = response.data?.items ? response.data.items : null;
                dispatch('setChats', {feature: payload.feature, chats: chats, adminHistory: adminHistory})
            })
        },
        async getChat({ rootState }, payload) {
            return axios.get(rootState.agentsUrl + `/v1/${payload.feature}/cids/${rootState.currentClient.cid}/chats/${payload.resourceId}`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async getChatMessages({ rootState }, payload) {
            return axios.get(rootState.agentsUrl + `/v1/${payload.feature}/cids/${rootState.currentClient.cid}/chats/${payload.resourceId}/messages`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async deleteChat({ rootState }, payload) {
            return axios.delete(rootState.agentsUrl + `/v1/${payload.feature}/cids/${rootState.currentClient.cid}/chats/${payload.resourceId}`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async fetchTemplateJobs({rootState, commit}) {
            axios.get(rootState.lakeviewUrl + `/v1/template_jobs`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            }).then((response) => {
                const templateJobs = response.data ? response.data: [];
                commit('setTemplateJobs', templateJobs)
            });
        },
        async readTemplateJob({rootState}, name) {
            return axios.get(rootState.lakeviewUrl + "/v1/template_jobs/" + name, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async fetchJobStacks({rootState, commit}) {
            axios.get(rootState.lakeviewUrl + `/v1/job_stacks`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            }).then((response) => {
                const jobStacks = response.data ? response.data: [];
                commit('setJobStacks', jobStacks)
            });
        },
        async upsertJobStack({rootState}, payload) {
            return axios.post(rootState.lakeviewUrl + "/v1/job_stacks", payload, {
                    headers: {
                        Authorization: `Bearer ${rootState.accessToken}`,
                    },
            })
        },
        async deleteJobStack({rootState}, name) {
            return axios.delete(rootState.lakeviewUrl + "/v1/job_stacks/" + name, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async readJobStack({rootState}, name) {
            return axios.get(rootState.lakeviewUrl + "/v1/job_stacks/" + name, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async deployJobStack({rootState}, payload) {
            return axios.post(`${rootState.lakeviewUrl}/v1/job_stacks/${payload.name}/deploy`, payload.data, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async fetchMeterLabels({rootState}) {
            return axios.get(rootState.lakeviewUrl + "/v1/meter-labels", {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async fetchJobStackDeployments({rootState}, sandboxName) {
            return axios.get(rootState.lakeviewUrl + `/v1/cids/${rootState.currentClient.cid}/sandboxes/${sandboxName}/deployments`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async readJobStackDeployment({rootState}, {sandboxName, deploymentId}) {
            return axios.get(rootState.lakeviewUrl + `/v1/cids/${rootState.currentClient.cid}/sandboxes/${sandboxName}/deployments/${deploymentId}`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        }
    }
}

export default store